import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

const { PaymentFrequencies, PurchaseMethodsValues } = PurchaseMethods;

export default {
    getPurchaseMethodLabel(purchaseMethod) {
        let purchaseMethodNameKey;

        switch (purchaseMethod) {
            case PurchaseMethodsValues.LEASE:
                purchaseMethodNameKey = 'TILE_A.PURCHASE_METHODS.LEASE';
                break;
            case PurchaseMethodsValues.FINANCE:
                purchaseMethodNameKey = 'TILE_A.PURCHASE_METHODS.FINANCE';
                break;
            default:
                purchaseMethodNameKey = 'TILE_A.PURCHASE_METHODS.CASH_PURCHASE';
                break;
        }

        return LocaleService.t(purchaseMethodNameKey);
    },

    getPaymentFrequencyLabel(frequency) {
        let frequencyLabelKey = '';

        switch (frequency) {
            case PaymentFrequencies.WEEKLY:
                frequencyLabelKey = 'TILE_A.PAYMENT_FREQUENCIES.WEEKLY';
                break;
            case PaymentFrequencies.BI_WEEKLY:
                frequencyLabelKey = 'TILE_A.PAYMENT_FREQUENCIES.BI_WEEKLY';

                break;
            case PaymentFrequencies.SEMI_MONTHLY:
                frequencyLabelKey = 'TILE_A.PAYMENT_FREQUENCIES.SEMI_MONTHLY';

                break;
            case PaymentFrequencies.MONTHLY:
                frequencyLabelKey = 'TILE_A.PAYMENT_FREQUENCIES.MONTHLY';
                break;
            default:
                break;
        }

        return LocaleService.t(frequencyLabelKey);
    },
};
